import { useCallback } from 'react';
import { getMetricInfo } from '../../constants';
import { isEmpty } from 'lodash';

const transform = (alert) => {
  const {
    name,
    attachment,
    cooldown,
    direction,
    emails,
    filterId,
    lifespan: ls,
    metric,
    priority,
    samples: s,
    state,
    threshold: th,
    type,
  } = alert;
  const metricsInfo = getMetricInfo();
  const threshold = metricsInfo[metric].units === 'Mbps' ? parseFloat(th) * 1e6 : parseFloat(th);
  const lifespan = ls ? JSON.stringify(ls) : '';
  const samples = parseInt(s, 10);
  return {
    name,
    attachment,
    cooldown,
    direction,
    emails,
    filterId,
    lifespan,
    metric,
    priority,
    samples,
    state,
    threshold,
    type,
  };
};

const useSave = ({
  alert,
  generalForm,
  advancedForm,
  createAlert,
  updateAlert,
  setAlert,
  setSaving,
}) => {
  const onSave = useCallback(() => {
    generalForm.validateFields().then(() => {
      const currentGeneralSettings = { ...alert, ...generalForm.getFieldsValue() };
      const currentAdvancedSettings = advancedForm ? advancedForm.getFieldsValue() : {};
      const metric = currentGeneralSettings.metric;
      const metricsInfo = getMetricInfo();

      let extra = {};
      // if alert is new and advanced settings are empty, set samples to default value
      if (!alert.id && isEmpty(currentAdvancedSettings)) {
        extra = { samples: metricsInfo[metric].cm_value };
      }

      const newAlert = {
        ...alert,
        ...currentGeneralSettings,
        ...currentAdvancedSettings,
        ...extra,
      };
      setAlert(newAlert);
      setSaving(true);

      if (!newAlert.id) {
        createAlert.mutate({
          payload: transform(newAlert),
        });
      } else {
        updateAlert.mutate({
          alertId: newAlert.id,
          payload: transform(newAlert),
        });
      }
    });
  }, [generalForm, alert, advancedForm]);
  return onSave;
};

export default useSave;
